// Bu composable parametrelerle gelecek
import { integrations, showGoogleStatusModal } from '../state'
// selectedIntegration ve showManageModal kaldırıldı

/**
 * Handles management action for the selected integration
 * @param {number} id - ID of the integration to manage
 */
export const openManageModal = async (id, loadGoogleAccounts) => {
  const integration = integrations.value.find((i) => i.id === id)
  if (!integration) return

  // Artık sadece Google ile ilgileniyoruz
  if (id === 6) {
    // Google status modal'ı göster
    showGoogleStatusModal.value = true
    
    try {
      await loadGoogleAccounts()
    } catch (error) {
      console.error('Failed to load Google accounts:', error)
    }
  } else {
    // Diğer entegrasyonları sadece loglama
    console.log('Managing integration:', integration.name)
  }
}
